import MaterialTabs, { TabsProps } from '@mui/material/Tabs';

export function Tabs(props: TabsProps) {
    return <MaterialTabs data-testid={'Tabs-container'} {...props} />;
}

export default Tabs;
